import React, { useEffect, useState } from "react";
import { Pagination } from "baseui/pagination";
import ItemList from "../../components/item-list/ItemList";
import ItemCard from "../../components/item-card/ItemCard";
import {Spinner, SIZE} from 'baseui/spinner';
import { RESOURCE_TYPES } from "../../constants/AppEnums";
import { styled } from "baseui";
import FetchErrorComponent from "../fetch-error/FetchErrorComponent";
import NoContentComponent from "../no-content/NoContentComponent";
import {withStyle} from 'baseui';
import LoadingOverlay from "../loading-overlay/LoadingOverlayComponent";

const ExtraLargeSpinner = withStyle(Spinner, {
  width: '100px',
  height: '100px',
  borderLeftWidth: '12px',
  borderRightWidth: '12px',
  borderTopWidth: '12px',
  borderBottomWidth: '12px',
});
const OuterContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  height: "80vh",
});

const ItemsListContainer = styled("div", ({ $theme, $viewMode }) => ({
  display: "flex",
  flexDirection: $viewMode === "list" ? "column" : "row", // Updated this line
  flexWrap: $viewMode === "list" ? "nowrap" : "wrap",
  margin: "0px 20px",
  justifyContent: "start",
  alignItems: "start",
  flex: 1, // This makes sure the container takes up all available space
}));
const MessageListContainer = styled("div", ({ $theme }) => ({
  display: "flex",
  margin: "0px 20px",
  justifyContent: "center",
  alignItems: "center",
  flex: 1, // This makes sure the container takes up all available space
}));
const PaginationContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "16px 0",
});

const PaginatedSearchList = ({  
  isLoading,
  retryFetch,
  error,
  errorMessage,
  items,
  viewMode,
  onCreateItem,
  onSelectItem,
  onPageChange,  
  currentPage,
  numPages,
  resourceType,
  onBuyItem,
  itemIsLoading
}) => {
  return (
    <OuterContainer>
      {isLoading || error ? (
        <MessageListContainer>
          {isLoading ? (
            <LoadingOverlay isLoading={isLoading} />
          ) : (
            <FetchErrorComponent error={error} message={errorMessage} onRefresh={retryFetch} />
          )}
        </MessageListContainer>
      ) : (!items || items.length === 0) ? (
        <MessageListContainer>
        <NoContentComponent onRefresh={retryFetch} />

        </MessageListContainer>
      ) : (
        <>
          <ItemsListContainer $viewMode={viewMode}>
            {items.map((item, index) => {
              return viewMode === "list" ? (
                <ItemList
                  editable={item.editable}
                  key={`item${item.id}`}
                  resourceType={resourceType}
                  item={item}
                  itemIsLoading={itemIsLoading?.[item.id] ?? false}
                  onCreateClick={() => onCreateItem && onCreateItem(item.id)}
                  onSelectClick={() => onSelectItem && onSelectItem(item.id)}
                  onBuyClick={() => onBuyItem && onBuyItem(item.id)}
                >
                  index
                </ItemList>
              ) : (
                <ItemCard
                  editable={item.editable}
                  key={`card${item.id}`}
                  resourceType={resourceType}
                  item={item}
                  onCreateClick={() => onCreateItem(item.id)}
                  onSelectClick={() => onSelectItem(item.id)}
                  onBuyClick={() => onBuyItem(item.id)}
                  itemIsLoading={itemIsLoading?.[item.id] ?? false}
                >
                  index
                </ItemCard>
              );
            })}
          </ItemsListContainer>
          <PaginationContainer>
            <Pagination
              size="mini"
              numPages={numPages ? numPages : 1}
              currentPage={currentPage}
              onPageChange={({ nextPage }) => {
                let p = Math.min(Math.max(nextPage, 1), numPages);
                onPageChange && onPageChange(p);
              }}
            />
          </PaginationContainer>
        </>
      )}
    </OuterContainer>
  );
};

export default PaginatedSearchList;

